import { UserRole } from "tm-shared/types";

export interface InfoTabShelvesCapabilities {
    canSeeShelves: boolean;
}

export const getInfoTabShelvesCapabilities = (
    role: UserRole | null,
): InfoTabShelvesCapabilities => ({
    canSeeShelves: Boolean(role),
});
